import { render } from "./gallery.vue?vue&type=template&id=28282e5c"
import script from "./gallery.vue?vue&type=script&lang=js"
export * from "./gallery.vue?vue&type=script&lang=js"

import "./gallery.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__